<template>
  <div id="submitted">
    <form>
      <ol class="questions">
        <li>
          <fieldset>
            <legend>
              <div class="alert alert-success" role="alert">
                <h2 id="submittedTitle"><i class="fa fa-check-circle"></i>Thank you for your request</h2>
                <p>Thank you for your request for us to review a historical life event.</p>
                <p>You have given us your contact details and we will respond to you request by email or telephone within 10 business days.</p>
              </div>
            </legend>
            <ul class="actions">
                <li>
                  <em><a v-on:click="resetForm" id="return" class="button">Return to page</a></em> 
                </li>
            </ul>
          </fieldset>
        </li>
      </ol>
    </form>
  </div>
</template>

<script>

export default {
  name: 'Submitted',
  props: { 
      resetEnquiry: Function      
  },
  methods: {
    resetForm: function() {
      this.$emit('resetEnquiry');
    }
  }
}
</script>
  
<style scoped lang="scss">
#submitted {
  min-height: 20em;
}
#return {
  margin-top: 3em;
  color: white !important;
  text-decoration: none !important;
}
</style>